import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
// components
import { RHFTextField } from '../../../../../components/hook-form';
import CardSection from '../../../../../components/card-section';

//-------------------------------------------------------------------------------------------------

const LocationFields = ({ onRemove, isRemoveDisabled, index }) => (
  <CardSection title={`Location #${index + 1}`} onRemove={() => onRemove(index)} isRemoveDisabled={isRemoveDisabled}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RHFTextField name={`locations[${index}].address`} label={'Street, City, State, Zip Code'} />
      </Grid>
    </Grid>
  </CardSection>
);

LocationFields.propTypes = {
  onRemove: PropTypes.func,
  isRemoveDisabled: PropTypes.bool,
  index: PropTypes.number,
};

export default LocationFields;
